module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/project-scrabblista.json
// module id = 381
// module chunks = 40474951444908